module.exports = __webpack_public_path__ + "img/imgZXGH(26).fae72b47.png";